export default __webpack_public_path__ + "images/QC.de4dc66.png";